// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../assets/css/tabs.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.growth-10k[data-v-0ff07e7a] {
  color: #333;
  font-family: 'AvenirNextLTW01-Regular', Arial;
  font-size: 14px;
}
.growth-10k img[data-v-0ff07e7a] {
  width: 100%;
}
.growth-10k .disclosure-link[data-v-0ff07e7a] {
  font-size: 14px;
  margin: 3px 0 20px 0;
}
.growth-10k .view-link[data-v-0ff07e7a] {
  color: #1d5799;
  font-family: Avenir Next LT W01 Demi, Arial, sans-serif;
  font-size: 14px;
  margin-top: 0px;
  text-decoration: none;
}
.bold-font[data-v-0ff07e7a] {
  font-family: 'Avenir Next LT W01 Demi', Arial;
}
.larger[data-v-0ff07e7a] {
  margin-top: 10px;
}
.chart-description[data-v-0ff07e7a] {
  font-family: 'AvenirNextLTW01-Regular', Arial;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 10px;
}
@media (max-width: 768px) {
.growth-10k .disclosure-link[data-v-0ff07e7a] {
    margin: 20px 0 0 0;
}
.growth-10k .view-link[data-v-0ff07e7a] {
    float: none !important;
    margin-left: -13px;
}
.growth-10k .chart-description[data-v-0ff07e7a] {
    margin-top: 20px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/growth-10k/Growth10k.vue","webpack://./Growth10k.vue"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,6CAAA;EACA,eAAA;ACAD;ADHA;EAKE,WAAA;ACCF;ADNA;EAQE,eAAA;EACA,oBAAA;ACCF;ADVA;EAYE,cAAA;EACA,uDAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;ACCF;ADEA;EACC,6CAAA;ACAD;ADGA;EACC,gBAAA;ACDD;ADGA;EACC,6CAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;ACDD;ADGA;AACC;IAEE,kBAAA;ACFD;ADAD;IAKE,sBAAA;IACA,kBAAA;ACFD;ADJD;IASE,gBAAA;ACFD;AACF","sourcesContent":["\n@import '~_css_/tabs.css';\n.growth-10k {\n\tcolor: #333;\n\tfont-family: 'AvenirNextLTW01-Regular', Arial;\n\tfont-size: 14px;\n\timg {\n\t\twidth: 100%;\n\t}\n\t.disclosure-link {\n\t\tfont-size: 14px;\n\t\tmargin: 3px 0 20px 0;\n\t}\n\t.view-link {\n\t\tcolor: #1d5799;\n\t\tfont-family: Avenir Next LT W01 Demi, Arial, sans-serif;\n\t\tfont-size: 14px;\n\t\tmargin-top: 0px;\n\t\ttext-decoration: none;\n\t}\n}\n.bold-font {\n\tfont-family: 'Avenir Next LT W01 Demi', Arial;\n}\n\n.larger {\n\tmargin-top: 10px;\n}\n.chart-description {\n\tfont-family: 'AvenirNextLTW01-Regular', Arial;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tmargin-bottom: 10px;\n}\n@media (max-width: 768px) {\n\t.growth-10k {\n\t\t.disclosure-link {\n\t\t\tmargin: 20px 0 0 0;\n\t\t}\n\t\t.view-link {\n\t\t\tfloat: none !important;\n\t\t\tmargin-left: -13px;\n\t\t}\n\t\t.chart-description {\n\t\t\tmargin-top: 20px;\n\t\t}\n\t}\n}\n","@import '~_css_/tabs.css';\n.growth-10k {\n  color: #333;\n  font-family: 'AvenirNextLTW01-Regular', Arial;\n  font-size: 14px;\n}\n.growth-10k img {\n  width: 100%;\n}\n.growth-10k .disclosure-link {\n  font-size: 14px;\n  margin: 3px 0 20px 0;\n}\n.growth-10k .view-link {\n  color: #1d5799;\n  font-family: Avenir Next LT W01 Demi, Arial, sans-serif;\n  font-size: 14px;\n  margin-top: 0px;\n  text-decoration: none;\n}\n.bold-font {\n  font-family: 'Avenir Next LT W01 Demi', Arial;\n}\n.larger {\n  margin-top: 10px;\n}\n.chart-description {\n  font-family: 'AvenirNextLTW01-Regular', Arial;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 10px;\n}\n@media (max-width: 768px) {\n  .growth-10k .disclosure-link {\n    margin: 20px 0 0 0;\n  }\n  .growth-10k .view-link {\n    float: none !important;\n    margin-left: -13px;\n  }\n  .growth-10k .chart-description {\n    margin-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
